// extracted by mini-css-extract-plugin
module.exports = {"root":"ChevronForwardCircleOutline_root__pyetG"};